import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'storyblokCdn',
  standalone: true,
})
export class StoryblokCdnPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.replace('//a.storyblok.com/f/234504', '//assets.picflow.com');
  }
}
